// Time display helpers. Storage/logic stays in 24-hour "HH:MM"; the UI ALWAYS
// renders in 12-hour AM/PM format across the whole app — no locale toggle.

/** formatTime("18:30") → "6:30 PM" */
export function formatTime(hhmm) {
  if (!hhmm || typeof hhmm !== "string") return hhmm || "";
  const m = hhmm.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return hhmm;
  const min = m[2];
  let h = parseInt(m[1], 10);
  if (isNaN(h)) return hhmm;
  const suffix = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${min} ${suffix}`;
}

/** formatTimeRange("17:30", "19:30") → "5:30 PM – 7:30 PM". */
export function formatTimeRange(from, to) {
  if (!from && !to) return "";
  if (!to) return formatTime(from);
  if (!from) return formatTime(to);
  return `${formatTime(from)} – ${formatTime(to)}`;
}
